module.exports = __webpack_public_path__ + "static/img/index-top-right-1.6eb7bcd9.png";